import {Component, Input, OnInit} from '@angular/core';
import {EventResponse} from "../../../model/response/event/event-response.model";
import {DropdownAbled} from "../../../interfaces/dropdown-abled";

@Component({
    selector: 'app-event-table-list',
    templateUrl: './event-table-list.component.html',
    standalone: false
})
export class EventTableListComponent implements OnInit, DropdownAbled<EventResponse> {

  @Input('events') events: EventResponse[]
  @Input('hasEvents') hasEvents: boolean
  @Input('hideTerminationDate') hideTerminationDate: boolean
  @Input('hideStatus') hideStatus: boolean
  @Input('isToRemoveTable') isToRemoveTable: boolean = false


  public mouseEvent: MouseEvent

  selectedEvent: EventResponse

  constructor() {
  }

  ngOnInit(): void {
  }

  onEditEvent($event: EventResponse) {
    const editedEventIndex = this.events.findIndex(el => el.id == $event.id)
    this.events[editedEventIndex] = $event
  }

  removeEventFromList($eventId: number) {
    this.events = this.events.filter(el => el.id !== $eventId)
    if (this.events.length == 0) this.hasEvents = false
  }

  onEventRestoreToRemove($event: EventResponse) {
    console.log($event)
    this.isToRemoveTable ? this.removeEventFromList($event.id) : this.onEditEvent($event)
  }

  // dropdown interface ----------------
  selectObjectForDropDown(event: EventResponse) {
    this.selectedEvent = event;
  }

  setMouseEvent($mouseEvent: MouseEvent) {
    this.mouseEvent = $mouseEvent
  }

}
